import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Clock } from 'lucide-react';

const Footer = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/33767632259', '_blank');
  };

  const handleInstagram = () => {
    window.open('https://instagram.com/pablocoiffure', '_blank');
  };

  return (
    <footer className="bg-secondary/50 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo et Description */}
          <div className="space-y-4">
            <img 
              src="/images/pablo-coiffure-logo.png" 
              alt="Pablo Coiffure Logo" 
              className="h-12 w-auto"
            />
            <p className="text-muted-foreground text-sm leading-relaxed">
              L'art de sublimer hommes et femmes. Votre beauté mérite l'excellence.
            </p>
            <div className="flex space-x-4">
              <button
                onClick={handleInstagram}
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </button>
            </div>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-primary">Navigation</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-muted-foreground hover:text-primary transition-colors">
                Accueil
              </Link>
              <Link to="/about" className="block text-muted-foreground hover:text-primary transition-colors">
                À propos
              </Link>
              <Link to="/services" className="block text-muted-foreground hover:text-primary transition-colors">
                Services
              </Link>
              <Link to="/gallery" className="block text-muted-foreground hover:text-primary transition-colors">
                Galerie
              </Link>
              <Link to="/booking" className="block text-muted-foreground hover:text-primary transition-colors">
                Réservation
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-primary">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                <div className="text-sm text-muted-foreground">
                  <p>94 Grande Rue de la Guillotière</p>
                  <p>69007 Lyon</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-primary flex-shrink-0" />
                <a 
                  href="tel:+33767632259"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  +33 7 67 63 22 59
                </a>
              </div>
              
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-primary flex-shrink-0" />
                <a 
                  href="mailto:paulodomingos332@gmail.com"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  paulodomingos332@gmail.com
                </a>
              </div>
              
              <div className="flex items-start space-x-3">
                <Clock className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                <div className="text-sm text-muted-foreground">
                  <p>Lundi au Samedi</p>
                  <p className="text-primary font-medium">Ouvert 24h/24</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-muted-foreground">
              © 2024 Pablo Coiffure. Tous droits réservés.
            </p>
            <button
              onClick={handleWhatsApp}
              className="mt-4 md:mt-0 text-sm text-primary hover:text-primary-glow transition-colors"
            >
              Réserver sur WhatsApp
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;